/**
 * Author: Hurman
 * Email: HurmanKz@hotmail.com
 */
export default {
  english: {
    default: [
      "`", "1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "-", "=", "Delete",
      "Tab", "q", "w", "e", "r", "t", "y", "u", "i", "o", "p", "[", "]", "\\",
      "Caps", "a", "s", "d", "f", "g", "h", "j", "k", "l", ";", "'", "Enter",
      "Shift", "z", "x", "c", "v", "b", "n", "m", ",", ".", "/", "Shift", 
      "Ctrl", "Alt", "Space", "Alt", "Ctrl"
    ],
    shifted: [
      "~", "!", "@", "#", "$", "%", "^", "&", "*", "(", ")", "_", "+", "Delete",
      "Tab", "Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P", "{", "}", "|",
      "Caps", "A", "S", "D", "F", "G", "H", "J", "K", "L", ":", "\"", "Enter",
      "Shift", "Z", "X", "C", "V", "B", "N", "M", "<", ">", "?", "Shift", 
      "Ctrl", "Alt", "Space", "Alt", "Ctrl"
    ],
    capsed: [
      "`", "1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "-", "=", "Delete",
      "Tab", "Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P", "[", "]", "\\",
      "Caps", "A", "S", "D", "F", "G", "H", "J", "K", "L", ";", "'", "Enter",
      "Shift", "Z", "X", "C", "V", "B", "N", "M", ",", ".", "/", "Shift", 
      "Ctrl", "Alt", "Space", "Alt", "Ctrl"
    ]
  },
  kazakhCyrl: {
    default: [
      "(", "\"", "ә", "і", "ң", "ғ", ",", ".", "ү", "ұ", "қ", "ө", "һ", "Delete",
      "Tab", "й", "ц", "у", "к", "е", "н", "г", "ш", "щ", "з", "х", "ъ", "\\",
      "Caps", "ф", "ы", "в", "а", "п", "р", "о", "л", "д", "ж", "э", "Enter",
      "Shift", "я", "ч", "с", "м", "и", "т", "ь", "б", "ю", "№", "Shift", 
      "Ctrl", "Alt", "Space", "Alt", "Ctrl"
    ],
    shifted: [
      ")", "!", "Ә", "І", "Ң", "Ғ", ";", ":", "Ү", "Ұ", "Қ", "Ө", "Һ", "Delete",
      "Tab", "Й", "Ц", "У", "К", "Е", "Н", "Г", "Ш", "Щ", "З", "Х", "Ъ", "/",
      "Caps", "Ф", "Ы", "В", "А", "П", "Р", "О", "Л", "Д", "Ж", "Э", "Enter",
      "Shift", "Я", "Ч", "С", "М", "И", "Т", "Ь", "Б", "Ю", "?", "Shift", 
      "Ctrl", "Alt", "Space", "Alt", "Ctrl"
    ],
    capsed: [
      ")", "!", "Ә", "І", "Ң", "Ғ", ";", ":", "Ү", "Ұ", "Қ", "Ө", "Һ", "Delete",
      "Tab", "Й", "Ц", "У", "К", "Е", "Н", "Г", "Ш", "Щ", "З", "Х", "Ъ", "/",
      "Caps", "Ф", "Ы", "В", "А", "П", "Р", "О", "Л", "Д", "Ж", "Э", "Enter",
      "Shift", "Я", "Ч", "С", "М", "И", "Т", "Ь", "Б", "Ю", "?", "Shift", 
      "Ctrl", "Alt", "Space", "Alt", "Ctrl"
    ]
  },
  kazakhTote: {
    default: [
      "`", "1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "-", "=", "Delete",
      "Tab", "چ", "ۋ", "ء", "ر", "ت", "ي", "ۇ", "ڭ", "و", "پ", "]", "[", "\\",
      "Caps", "ھ", "س", "د", "ا", "ە", "ى", "ق", "ك", "ل", "؛", "'", "Enter",
      "Shift", "ز", "ش", "ع", "ۆ", "ب", "ن", "م", "،", ".", "/", "Shift", 
      "Ctrl", "Alt", "Space", "Alt", "Ctrl"
    ],
    shifted: [
      "~", "!", "@", "#", "$", "%", "^", "&", "*", "(", ")", "_", "+", "Delete",
      "Tab", "چ", "ۋ", "ە", "ر", "ت", "ي", "ۇ", "ڭ", "و", "پ", "}", "{", "|",
      "Caps", "—", "س", "د", "ف", "گ", "ح", "ج", "ۆ", "ل", "؛", "'", "Enter",
      "Shift", "ز", "ش", "ع", "ۆ", "ب", "ن", "م", "،", ".", "/", "Shift", 
      "Ctrl", "Alt", "Space", "Alt", "Ctrl"
    ],
    capsed: [
      "`", "1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "-", "=", "Delete",
      "Tab", "چ", "ۋ", "ء", "ر", "ت", "ي", "ۇ", "ڭ", "و", "پ", "]", "[", "\\",
      "Caps", "—", "س", "د", "ف", "گ", "ح", "ج", "ۆ", "ل", ":", "‹", "Enter",
      "Shift", "ز", "ش", "ع", "ۆ", "ب", "ن", "م", ",", ".", "/", "Shift",
      "Ctrl", "Alt", "Space", "Alt", "Ctrl"
    ]
  },
  kazakhLatyn: {
    default: [
      "\\", "1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "-", "=", "Delete",
      "Tab", "q", "á", "e", "r", "t", "y", "u", "i̇", "o", "p", "ó", "ú", "ı",
      "Caps", "a", "s", "d", "f", "g", "h", "j", "k", "l", "ń", "ý", "Enter",
      "Shift", "z", "ǵ", "c", "v", "b", "n", "m", ",", ".", "/", "Shift", 
      "Ctrl", "Alt", "Space", "Alt", "Ctrl"
    ],
    shifted: [
      "|", "!", "@", "#", "₸", "%", "^", "&", "*", "(", ")", "_", "+", "Delete",
      "Tab", "Q", "Á", "E", "R", "T", "Y", "U", "İ", "O", "P", "Ó", "Ú", "I",
      "Caps", "A", "S", "D", "F", "G", "H", "J", "K", "L", "Ń", "Ý", "Enter",
      "Shift", "Z", "Ǵ", "C", "V", "B", "N", "M", "<", ">", "?", "Shift", 
      "Ctrl", "Alt", "Space", "Alt", "Ctrl"
    ],
    capsed: [
      "\\", "1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "-", "=", "Delete",
      "Tab", "Q", "Á", "E", "R", "T", "Y", "U", "İ", "O", "P", "Ó", "Ú", "I",
      "Caps", "A", "S", "D", "F", "G", "H", "J", "K", "L", "Ń", "Ý", "Enter",
      "Shift", "Z", "Ǵ", "C", "V", "B", "N", "M", ",", ".", "/", "Shift", 
      "Ctrl", "Alt", "Space", "Alt", "Ctrl"
    ]
  }
};
